import clipboard from 'clipboard-copy';
import { useEffect, useState } from 'react';

interface IShare {
  shareLink: string;
  topSectionHeight?: number;
}

function Share({ shareLink, topSectionHeight }: IShare) {
  const [copied, setCopied] = useState(false);

  const copyLink = () => {
    clipboard(shareLink);
    setCopied(true);
  };

  useEffect(() => {
    if (copied) {
      setTimeout(() => {
        setCopied(false);
      }, 3000);
    }
  }, [copied]);

  return (
    <div
      className={`${
        topSectionHeight ? '' : 'border p-4'
      } min-h-[180px] mr-3 rounded-md text-black text-sm w-full md:w-[520px]`}
    >
      {topSectionHeight ? (
        <p
          className={`mb-2 border-b ${
            topSectionHeight ? 'text-xl font-semibold pt-0 pb-4 px-4' : 'font-bold text-base p-2'
          }`}
        >
          Share
        </p>
      ) : (
        <p className="font-bold text-base p-2">Share</p>
      )}
      <div
        className={`border border-tabBorder text-black px-3 py-2 flex items-center rounded-3xl justify-between ${
          topSectionHeight ? 'w-[calc(100%-16px)] mx-auto mt-4' : 'w-full'
        }`}
      >
        <div className="truncate">{shareLink}</div>
        <button
          className="bg-red-main hover:bg-red-main text-white font-bold py-2 px-4 rounded-full focus:outline-none focus:shadow-outline ml-2"
          disabled={!shareLink}
          onClick={copyLink}
        >
          Copy
        </button>
      </div>
      {copied && (
        <div className="w-44 text-white py-3 flex items-center rounded-xl justify-center mt-3 bg-black">
          Link copied to clipboard
        </div>
      )}
    </div>
  );
}

export default Share;
